// extracted by mini-css-extract-plugin
export default {"container":"TagPage_container__2se41","textContainer":"TagPage_textContainer__clvE8","productCard":"TagPage_productCard__hyNVI"};